import { Instagram, Mail, MapPin, Phone } from "lucide-react";
import { assets, contact } from "@/lib/site-data";

const footerNav = [
  { label: "Domov", href: "/" },
  { label: "O nás", href: "/#o-nas" },
  { label: "Služby", href: "/#sluzby" },
  { label: "Realizácie", href: "/realizacia" },
  { label: "Referencie", href: "/#referencie" },
  { label: "Kontakt", href: "/kontakt" },
];

export function Footer() {
  return (
    <footer className="bg-charcoal text-charcoal-foreground">
      <div className="container-artbaz content-artbaz py-16 md:py-20">
        <div className="grid gap-12 md:grid-cols-3 md:gap-10">
          {/* Column 1 — logo + description */}
          <div className="max-w-sm">
            <img src={assets.logoMark} alt="ARTBAZ" className="h-20 w-auto" />
            <p className="mt-6 text-sm leading-relaxed text-charcoal-muted">
              Komplexné rekonštrukcie, stavby a realizácie s dôrazom na kvalitu, detail a
              profesionálny prístup.
            </p>
          </div>

          {/* Column 2 — navigation */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-white">Navigácia</h3>
            <ul className="mt-6 space-y-3">
              {footerNav.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-charcoal-muted transition-colors hover:text-primary"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 — contact */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-white">Kontaktné údaje</h3>
            <ul className="mt-6 space-y-4 text-sm text-charcoal-muted">
              <li>
                <a
                  href={`mailto:${contact.email}`}
                  className="flex items-center gap-3 transition-colors hover:text-primary"
                >
                  <Mail className="size-5 shrink-0 text-primary" />
                  {contact.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${contact.phoneHref}`}
                  className="flex items-center gap-3 transition-colors hover:text-primary"
                >
                  <Phone className="size-5 shrink-0 text-primary" />
                  {contact.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 size-5 shrink-0 text-primary" />
                <span>
                  {contact.address[0]}
                  <br />
                  {contact.address[1]}
                </span>
              </li>
            </ul>

            <a
              href={contact.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 rounded-full border border-white/20 px-5 py-2.5 text-sm font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 hover:border-primary hover:text-primary"
            >
              <Instagram className="size-4" />
              Instagram
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-7 text-xs text-charcoal-muted sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 ARTBAZ. Všetky práva vyhradené.</p>
          <a
            href="/ochrana-osobnych-udajov"
            className="transition-colors hover:text-primary"
          >
            Ochrana osobných údajov
          </a>
        </div>

      </div>
    </footer>
  );
}
